"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actions_utils_1 = require("../utils/actions-utils");
var COOKIES_NAMESPACE = "cookies";
exports.COOKIES_FEATURE = actions_utils_1.createActionTypeRunner(COOKIES_NAMESPACE);
exports.initializeCookies = function (dataDomain, theme, testMode) {
    if (testMode === void 0) { testMode = false; }
    return ({
        type: exports.COOKIES_FEATURE.INIT,
        payload: {
            dataDomain: dataDomain,
            theme: theme,
            testMode: testMode,
        },
    });
};
exports.cookiesInitialized = function () { return ({
    type: exports.COOKIES_FEATURE.SUCCESS,
}); };
